import { Button } from '@design-system';

interface QuestionnaireIntroScreenProps {
  onStart: () => void;
}

export function QuestionnaireIntroScreen({ onStart }: QuestionnaireIntroScreenProps) {
  return (
    <div className="flex flex-col items-center px-4 sm:px-0">
      <div className="w-full max-w-lg space-y-8 text-center">
        <h2 className="text-2xl font-semibold text-gray-950 sm:text-3xl">
          Let's tailor Waterlily to you
        </h2>
        <p className="text-foreground text-base sm:text-lg">
          We're going to ask you a few quick questions to personalize Waterlily to fit your workflow
          and help you achieve your goals.
        </p>
        <Button
          size="lg"
          onClick={onStart}
        >
          Let's go
        </Button>
      </div>
    </div>
  );
}
